import { BatchSelectionRow } from "../types";

export function getEmptyRow(): BatchSelectionRow {
  return {
    additionalReference: "",
    differentialTemperature: "",
    dp: "",
    flow: "",
    id: crypto.randomUUID(),
    output: {
      pipeResult: null,
      status: "idle",
      subProductsSelection: null,
      suggestion: null,
    },
    pipeSize: "",
    power: "",
    quantity: "",
    reference: "",
  };
}
